import { useQuery } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'
import type { components } from '../api/tipos'

export type ProductosMasConsumidos = components['schemas']['ProductosMasConsumidos']
export type ProductoConsumido = components['schemas']['ProductoConsumido']

export interface OpcionesProductos {
  meses?: number
  limite?: number
  /**
   * Cada llamada recorre las facturas de Holded y tarda segundos. La consulta
   * solo se lanza cuando alguien abre el panel que la necesita, nunca al
   * montar la pagina.
   */
  activo?: boolean
}

export function useProductos({ meses = 3, limite = 10, activo = false }: OpcionesProductos = {}) {
  const api = useApi()

  return useQuery<ProductosMasConsumidos, ErrorApi>({
    queryKey: ['productos-mas-consumidos', meses, limite],
    queryFn: ({ signal }) =>
      api.pedir<ProductosMasConsumidos>('/api/productos/mas-consumidos', {
        parametros: { meses, limite },
        senal: signal,
      }),
    enabled: activo,
    // Es cara: una vez traida, vale para toda la sesion de trabajo.
    staleTime: 10 * 60_000,
    // Un 503 significa que Holded no contesta. La politica global reintentaria
    // dos veces mas, es decir tres recorridos completos de las facturas contra
    // la API real de facturacion justo cuando esta caida. Reintentar en bucle no
    // lo arregla: el reintento aqui lo decide el operador con el boton, igual
    // que en `useUltimaFactura`.
    retry: false,
  })
}
